import { load3DLogo } from '../../vendor/index.js';

export default {
	init() {
		$(document).ready(function () {
			//init 3D logo

			let scene3D;
			const logoContainer = $('.wrap_popup .logo_3d');
			if (window.matchMedia('(min-width: 1100px)').matches) {
				logoContainer.css({ display: 'none' });
				load3DLogo({ container: logoContainer[0], dark: true }).then(
					(scene) => {
						scene3D = scene;
						scene3D.pause();
					}
				);
			}

			var import_url;
			var import_url2;

			MutationObserver =
				window.MutationObserver || window.WebKitMutationObserver;

			var observer = new MutationObserver(function (mutations, observer) {
				$(
					'.module-popup-contact .gform-body .gform_fields .buttons_wrapper .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice img'
				).each(function () {
					import_url = $(this).attr('src');
					$(this)
						.parent()
						.css('mask-image', 'url(' + import_url + ')');
				});

				$(
					'.module-popup-contact .gform-body .gform_fields .postule .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice img'
				).each(function () {
					import_url2 = $(this).attr('src');
					$(this)
						.parent()
						.css('mask-image', 'url(' + import_url2 + ')');
				});

				$('.first_template .ginput_container .gchoice').each(function (
					index
				) {
					if ($(this).find('input').is(':checked')) {
						switch (index) {
							case 0:
								$('.last_form').addClass('first_form');
								$(
									'.module-popup-contact .gform-body .gform_fields .input_file_red_box .ginput_container_fileupload input[type=file]'
								).change(function () {
									var file = $(
										'.module-popup-contact .gform-body .gform_fields .input_file_red_box .ginput_container_fileupload input[type=file]'
									)[0].files[0].name;
									$(this)
										.parent()
										.prev('label')
										.attr(
											'style',
											'display: block !important'
										);
									$(this).parent().prev('label').text(file);
								});
								break;

							case 1:
								$('.last_form').addClass('second_form');
								$(
									'.module-popup-contact .gform-body .second_form .gform_fields .input_file_red_box .ginput_container_fileupload input[type=file]'
								).change(function () {
									var file = $(
										'.module-popup-contact .gform-body .second_form .gform_fields .input_file_red_box .ginput_container_fileupload input[type=file]'
									)[0].files[0].name;
									$(this)
										.nextAll('label.gfield_label')
										.attr(
											'style',
											'display: block !important'
										);
									$(this)
										.nextAll('label.gfield_label')
										.text(file);
								});
								break;

							case 2:
								$('.last_form').addClass('third_form');
								logoContainer.css({ display: 'none' });

								break;
						}
					}
				});
			});

			observer.observe(document.getElementsByClassName('wrap_popup')[0], {
				subtree: true,
				attributes: true,
			});

			function openPopup() {
				$('.popup_form').addClass('open');
				$('html').addClass('popup');
				$('.module-popup-contact').css({ pointerEvents: 'auto' });
				if (
					$('.module-popup-contact .popup_form .popup_content').find(
						'.gform_confirmation_wrapper'
					).length !== 0
				) {
					$(
						'.module-popup-contact .popup_form .wrap_popup .logo_3d'
					).css('display', 'block');
				}
				if (
					scene3D &&
					window.matchMedia('(min-width: 1100px)').matches
				) {
					scene3D.play();
				}
				jQuery(document).off('gform_post_render', openPopup);
			}

			function openPopupWithChoice(number) {
				const $popupChoice = $(
					`.popup_form .first-choices .gchoice:nth-child(${number}) input`
				);

				$popupChoice.trigger('click');
				$('.popup_content').addClass('accessDirect');

				jQuery(document).on('gform_post_render', openPopup);
			}

			const $link = window.location.href;
			const $url = new URL($link);
			const $openModal = $url.searchParams.get('openModal');

			if ($openModal) {
				openPopupWithChoice($openModal);
			}

			// Open popup through the buttons in the footer
			$(
				'body:not(.page-template-template-calculateur-de-prix) button[data-popup]'
			).on('click', function (event) {
				event.preventDefault();

				const $dataPopup = $(this).data('popup');
				openPopupWithChoice($dataPopup);
			});

			$('.popup_form .close').on('click', function () {
				const formId = document
					.querySelector('.popup_content')
					.getAttribute('data-formId');

				$('.popup_form').removeClass('open');
				$('html').removeClass('popup');
				$('.module-popup-contact').css({ pointerEvents: 'none' });

				//Simulate back button
				$('.popup_content').removeClass('accessDirect');
				$(`#gform_target_page_number_${formId}`).val('1');
				$(`#gform_${formId}`).trigger('submit', [true]);

				if (
					scene3D &&
					window.matchMedia('(min-width: 1100px)').matches
				) {
					scene3D.pause();
				}
			});

			// send event to GTM when the use make a choice one the first page of the popup
			gform.addAction(
				'gform_input_change',
				function (input, formId, fieldId) {
					if (
						(formId === '42' || formId === '56') &&
						(fieldId === '1.0' ||
							fieldId === '1.1' ||
							fieldId === '1.2')
					) {
						dataLayer.push({
							event: 'popupChangePage',
							popupChoice: input.value,
						});
					}
				},
				10,
				3
			);

			jQuery(document).on(
				'gform_page_loaded',
				function (event, form_id, current_page) {
					if (current_page === '1') {
						logoContainer.fadeOut(200);

						setTimeout(function () {
							const checkInterval = setInterval(function () {
								if (
									$('.module-popup-contact').find(
										'.first-choices .image-choices-choice-selected'
									).length
								) {
									$('.module-popup-contact')
										.find(
											'.first-choices .image-choices-choice-selected'
										)
										.removeClass(
											'image-choices-choice-selected'
										);
									clearInterval(checkInterval);
								}
							}, 100);
						}, 200);
					} else {
						logoContainer.fadeIn(200);
					}

					$(
						'.module-popup-contact .gform-body .gform_fields .choix_1 input, .module-popup-contact .gform-body .gform_fields .choix_2 input'
					).attr(
						'title',
						'Username should only contain lowercase letters. e.g. john'
					);
					$(
						'.module-popup-contact .gform-body .gform_fields .choix_3 input'
					).attr('title', 'Invalid email address');
					$(
						'.module-popup-contact .gform-body .gform_fields .choix_4 input'
					).attr('title', 'Invalid Téléphone');

					if (current_page == '6') {
						$(
							'.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
						).each(function () {
							$(this).next().append($(this));
						});

						$(
							'.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email'
						).each(function () {
							$(this).append(
								'<span class="focus-border"></span>'
							);
						});

						$(
							'.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input'
						).each(function () {
							$(this).focusout(function () {
								if ($(this).val() != '') {
									$(this).addClass('has-content');
								} else {
									$(this).removeClass('has-content');
									$(this).val('');
									// $('.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input').val('');
								}
							});
						});

						$(
							'.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input'
						).each(function () {
							if ($(this).val() != '') {
								$(this).addClass('has-content');
							} else {
								$(this).removeClass('has-content');
								$(this).val('');
							}
						});
					}

					if (current_page == '3') {
						$(
							'.popup_content .gform_body .third_template .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea'
						).append(function () {
							var label_inside = $(
								'.popup_content .gform_body .third_template .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label'
							);
							return label_inside;
						});
						$(
							'.popup_content .gform_body .third_template .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea textarea'
						).each(function () {
							$(this).focusout(function () {
								if ($(this).val() != '') {
									$(this).addClass('has-content');
								} else {
									$(this).removeClass('has-content');
									$(this).val('');
									// $('.popup_content .gform_body .last_form .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input').val('');
								}
							});
						});

						$(
							' .popup_content .gform_body .third_template .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea textarea.large'
						).each(function () {
							if ($(this).val() != '') {
								$(this).addClass('has-content');
							} else {
								$(this).removeClass('has-content');
								$(this).val('');
							}
						});
					}
				}
			);
		});
	},
};
